const domainWhitelist = [
  { match: 'aemo.com.au' },
  { match: '*.aemo.com.au', replace: 'aemo.com.au' },
  { match: 'corp-stc-prd-rg-aue-cm.azurewebsites.net' },
  { match: 'corp-stc-prd-rg-aue-cd.azurewebsites.net' },
  { match: 'cd.prd.aemo-sitecore.com.au' }
];

export function configurePageDomain() {
  const parentDomain = getParentDomain();

  if (parentDomain) {
    let domainMatch = findMatchingDomain(parentDomain);
    if (domainMatch && document.location.hostname.endsWith(domainMatch.replace ? domainMatch.replace : domainMatch.match))
      document.domain = domainMatch.replace ? domainMatch.replace : domainMatch.match;
  }
}

export function getWhitelistedParentUrl() : string {
  return 'https://' + getWhitelistedParentDomain();
}

export function getWhitelistedParentDomain() : string {
  const parentDomain = getParentDomain();
  if (parentDomain && findMatchingDomain(parentDomain)) {
    return parentDomain;
  }

  return 'www.aemo.com.au';
}

function findMatchingDomain(parentDomain: string) {
  return domainWhitelist.find(x => {
    if (x.match.startsWith('*') && parentDomain.toLowerCase().endsWith(x.match.substr(1))) {
      return true;
    } else if (parentDomain.toLowerCase() === x.match) {
      return true
    }
    return false;
  });
}

export function getParentDomain() : string {
  let parentUrl = document.referrer;

  if (parentUrl) {
    // Strip trailing slashes
    const lastSlashIndex = parentUrl.lastIndexOf('/');
    if (lastSlashIndex > 7)
      parentUrl = parentUrl.substr(0, lastSlashIndex);
    // Strip query string
    const lastQueryIndex = parentUrl.lastIndexOf('?');
    if (lastQueryIndex > 7)
      parentUrl = parentUrl.substr(0, lastQueryIndex);
    // Remove protocal
    parentUrl = parentUrl.replace('https://', '');
    parentUrl = parentUrl.replace('http://', '');

    return parentUrl;
  }
}




// WEBPACK FOOTER //
// src/helpers/environment.ts